import { FC } from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import EmailOutline from 'ui/components/Icons/EmailOutline';
import PhoneTwo from 'ui/components/Icons/PhoneTwo';
import { formatPhoneNumber } from '../../helpers/formatPhoneNumber';
export interface CbContactCardProps extends BoxProps {
  email?: string;
  phone?: string;
}
export const CbContactCard: FC<CbContactCardProps> = ({
  email,
  phone,
  ...props
}) => {
  return <Box {...props} data-sentry-element="Box" data-sentry-component="CbContactCard" data-sentry-source-file="CbContactCard.tsx">
      {email && <Flex alignItems={{
      base: 'center',
      lg: 'flex-start'
    }} flexDirection={{
      lg: 'column'
    }}>
          <EmailOutline marginRight={{
        base: 2,
        lg: 0
      }} height={{
        base: '24px',
        lg: '16px'
      }} width={{
        base: '24px',
        lg: '16px'
      }} color="chonky.500" />
          <Text as="a" href={`mailto:${email}`} color="text.secondary" fontSize={{
        base: 'md',
        lg: 'sm'
      }}>
            {email}
          </Text>
        </Flex>}
      {phone && <Flex alignItems={{
      base: 'center',
      lg: 'flex-start'
    }} flexDirection={{
      lg: 'column'
    }} marginTop={email ? 3 : 0}>
          <PhoneTwo marginRight={{
        base: 2,
        lg: 0
      }} marginBottom={{
        base: 0,
        lg: 1
      }} height={{
        base: '24px',
        lg: '16px'
      }} width={{
        base: '24px',
        lg: '16px'
      }} color="chonky.500" />
          <Text as="a" href={`tel:+${phone}`} color="text.secondary" fontSize={{
        base: 'md',
        lg: 'sm'
      }}>
            {formatPhoneNumber(phone)}
          </Text>
        </Flex>}
    </Box>;
};